module.exports = __webpack_public_path__ + "static/img/fun5.580de9f4.png";